import { encryptStorage } from '@/utils/storage';
import ContactService from '@/services/ContactService.js';

function processContacts(contacts) {
  const dialogs = [];
  for (let index = 0; index < contacts.length; index++) {
    const contact = contacts[index];
    // const dateMessage = new Date(sender.date_message)
    const dialog = {
      id: contact.id,
      name: contact.nombre,
      last_message: `${contact.mobile} ${contact.company !== undefined ? contact.company : ''}`,
      number: contact.mobile.replace("+", "").trim(),
      status: contact.status,
      avatar: contact.avatar,
    };
    dialogs.push(dialog);
  }
  return dialogs;
}

const contact = {
  namespaced: true,
  state: {
    contacts: [],
    loadingContacts: false,
    page: 1,
  },
  mutations: {
    TOGGLE_LOADING(state, status) {
      state.loadingContacts = status;
    },
    LOAD_CONTACTS(state, contacts) {
      state.contacts = contacts;
    },
    CLEAR_CONTACTS(state) {
      state.contacts = [];
    },
  },
  actions: {
    async fetchContacts({ state, commit }, query) {
      commit('TOGGLE_LOADING', true);
      // console.log(state.loadingContacts, query);
      const username = encryptStorage.getItem('user').Username;
      return ContactService.getContacts(query, username)
        .then((response) => {
          // console.log('retriving contacts for page ', state.page, response);
          commit('LOAD_CONTACTS', response.data.results);
          commit('TOGGLE_LOADING', false);
          if (response.data.next !== null) {
            state.page += 1;
            console.log(
              'There are more contacts to load next page : ',
              state.page
            );
          } else {
            // console.log('No more contacts to load');
            state.page = 0;
          }
          return 'Success';
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async fetchPbxContacts({ state, commit }, query) {
      commit('TOGGLE_LOADING', true);
      // console.log(state.loadingContacts, query);
      const username = encryptStorage.getItem('user').Username;
      return ContactService.getPbxContacts(query, username)
        .then((response) => {
          console.log('retriving contacts for page ', response);
          const contacts = processContacts(response.data.contacts);
          commit('LOAD_CONTACTS', contacts);
          // commit('TOGGLE_LOADING', false);
          if (response.data.next !== null) {
            state.page += 1;
            console.log(
              'There are more contacts to load next page : ',
              state.page
            );
          } else {
            // console.log('No more contacts to load');
            state.page = 0;
          }
          return 'Success';
        })
        .catch((error) => {
          console.log(error);
        });
    },
    stopLoading({ state, commit }) {
      commit('CLEAR_CONTACTS');
      state.loadingContacts = false;
    },
    async createAndUpdateSender(
      { commit, dispatch, rootState },
      { token, contact }
    ) {
      await dispatch('chat/getOrCreateChat', contact.number, { root: true });
      return ContactService.updateCustomName(token, contact).then(
        (response) => {
          const chats = rootState.chat.chats.filter(
            (x) => x.phone === response.data.sender.phone
          )[0];
          chats.custom_name = response.data.sender.custom_name;
          commit('chat/SET_CHAT', chats, { root: true });
          dispatch('chat/updateUnread', chats.id, { root: true });
        }
      );
    },
    async updateCustomName({ dispatch }, contact) {
      const join = encryptStorage.getItem('user').join
      const userName = encryptStorage.getItem('user').Username;
      const token = join.token;
      return ContactService.updateCustomName(userName, token, contact)
        .then((response) => {
          dispatch('chat/fetchChat', [response.data.sender], { root: true });
          dispatch('chat/getOrCreateChat', response.data.sender.phone, {
            root: true,
          });
          // dispatch('chat/getOrCreateChat', response.data.sender.custom_name, {
          //   root: true,
          // });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async updateConversationName(_, contact) {
      const join = encryptStorage.getItem('user').join
      const userName = encryptStorage.getItem('user').Username;
      const token = join.token;
      return ContactService.updateCustomName(userName, token, contact)
        .then(() => {
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};

export default contact;
